import React from 'react';
import { Window } from '../Window/Window';
import styled from 'styled-components';

const Container = styled.div`
  background: #C0C0C0;
  padding: 20px;
  height: calc(100% - 30px);
  font-family: 'Perfect DOS VGA 437', monospace;
  white-space: pre-wrap;
  line-height: 1.5;
  overflow-y: auto;
  
  &::-webkit-scrollbar {
    width: 16px;
  }
  
  &::-webkit-scrollbar-track {
    background: #c0c0c0;
    border-left: 1px solid #808080;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #808080;
    border: 1px solid #c0c0c0;
    border-right: 1px solid #000;
    border-bottom: 1px solid #000;
  }
`;

const Title = styled.h1`
  color: #000080;
  margin-bottom: 20px;
  text-align: center;
`;

const Section = styled.div`
  margin-bottom: 20px;
  line-height: 1.5;
`;

const Link = styled.a`
  color: #000080;
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    color: #0000ff;
  }
`;

const Image = styled.img`
  width: 400px;
  height: auto;
  margin: 10px 0;
  border: 2px solid #808080;
  box-shadow: 2px 2px 5px rgba(0,0,0,0.2);
  display: block;
  margin-left: auto;
  margin-right: auto;
`;

export const DavidOSInfo = ({ 
  onClose, 
  isActive, 
  onActivate, 
  isMinimized, 
  isMaximized, 
  onMinimize, 
  onMaximize,
  initialPosition
}) => {
  return (
    <Window
      title="davidos.txt"
      onClose={onClose}
      isActive={isActive}
      onActivate={onActivate}
      isMinimized={isMinimized}
      isMaximized={isMaximized}
      onMinimize={onMinimize}
      onMaximize={onMaximize}
      defaultWidth="600px"
      defaultHeight="500px"
      initialPosition={initialPosition}
    >
      <Container>
        <Title>a file about DavidOS</Title>
        
        <Section>
          <i>your new favourite operating system</i>
        </Section>

        <Section>
          a bit over a year ago i saw <Link href="https://henryheffernan.com" target="_blank">henryheffernan.com</Link> and thought it was one of the coolest websites i've ever seen. so with recent developments of AI tools i decided to try building my own version. 
          <br></br>
          <br></br>
          enter DavidOS—a web-based operating system that's basically my little corner of the internet.
        </Section>

        <Section>
          this started as a fun side project but turned into something way bigger. i wanted a place to showcase what i'm working on, who i am, and all the random things i build—wrapped in a retro OS vibe because, well, i think it looks cool.
        </Section>

        <Section>
          <b>how it came together:</b>
          <br />
          • built using Cursor AI
          <br />
          • designed to feel like an old-school computer
        </Section>

        <Section>
          <Image 
            src="/images/desktop-screenshot.png" 
            alt="DavidOS desktop interface showing various icons and the retro-styled OS environment" 
          />
        </Section>

        <Section>
          packed with small details, fun interactions & some hidden surprises
        </Section>

        <Section>
          <b>the davidOS logo:</b>
          <br />
          i actually used gemini's image generation to try to create a logo, then i imported that into illustrator to make it look better. 
        </Section>

        <Section>
          <b>what's inside:</b>
          <br />
          • a projects folder (open it up, it's got all the good stuff & more coming)
          <br />
          • a resume (because i guess that's important)
          <br />
          • a built-in notepad & command prompt with some fun easter eggs
          <br />
          • AN MP3 PLAYER!!!!
          <br />
          • and some random extras just because
        </Section>

        <Section>
          <b>challenges faced:</b>
          <br />
          building this wasn't all smooth sailing. since i used Cursor AI to generate a lot of the site, the early stages were... unpredictable. random things popped up, features didn't quite work as expected, and some solutions were more interesting than functional.
        </Section>

        <Section>
          as the project grew, Cursor started struggling with the size of the codebase. it became harder for it to understand the full scope of what was happening, and getting it to generate new features without breaking existing ones took some troubleshooting. i had to step in and manually tweak a lot of things, fine-tune the design, and debug when AI went a little rogue.
        </Section>

        <Section>
          <b>future:</b>
          <br />
          DavidOS is far from finished. i've got some ideas for new features, like:
          <br />
          • customizable desktop themes
          <br />
          • at least 1 fun 3D game, something similar to Wolfenstein 3D (but probably called davidstein 3d)
          <br />
          • better file system
          <br />
          • a login screen where users can sign in as guest or create their own profile for a more personalised experience
          <br />
          • fix the damn chess pieces
          <br />
          • & more...
        </Section>

        <Section>
          find me on X <Link href="https://x.com/0xDavidR" target="_blank">@0xDavidR</Link>
        </Section>

        <Section style={{ fontSize: '12px', textAlign: 'center', color: '#666' }}>
          DavidOS v1.69 - way too much time was spent on this
        </Section>
      </Container>
    </Window>
  );
}; 